import { render, staticRenderFns } from "./CourseCatalog.vue?vue&type=template&id=3ff089e9&scoped=true&"
import script from "./CourseCatalog.vue?vue&type=script&lang=js&"
export * from "./CourseCatalog.vue?vue&type=script&lang=js&"
import style0 from "./CourseCatalog.vue?vue&type=style&index=0&id=3ff089e9&lang=scss&scoped=true&"
import style1 from "./CourseCatalog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff089e9",
  null
  
)

export default component.exports